<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-modal
            v-model="showModal"
            centered
            size="sm"
            title="Send Reminders"
            :cancel-disabled="loading || sending"
            :ok-disabled="loading || sending"
            @show="onModalShow"
            @hidden="onModalHidden"
            @ok="sendBulkReminder"
            @cancel="showModal = false"
        >
            <busy-spinner v-if="loading" key="loading" inner-class="my-5" text="Loading list of suppliers..."></busy-spinner>
            <div v-if="!loading" key="list" class="position-relative">
                <b-overlay :show="sending" no-wrap>
                    <template #overlay>
                        <transition name="fade-fast" mode="out-in">
                            <div v-if="saveComplete" key="saveComplete" class="text-center">
                                <b-icon icon="envelope-fill" variant="success" font-scale="3"></b-icon>
                                <h5 class="text-muted mt-4">Sent {{sentReminderCount}} Reminders</h5>
                            </div>
                            <div v-else key="saveNotComplete" class="text-center">
                                <b-icon icon="envelope-fill" variant="primary" animation="fade" font-scale="3"></b-icon>
                                <h5 class="text-muted mt-4">Sending Reminders</h5>
                            </div>
                        </transition>
                    </template>
                </b-overlay>
                <h5>Send reminders to {{ bulkReminderList.length }} vendors?:</h5>
                <ul class="list-flush mb-0">
                    <li v-for="response in bulkReminderList" :key="response.id">
                        {{ response.vendor_name }}
                        <status-object-badge :status-object="response.state_dict" class="ml-2"></status-object-badge>
                    </li>
                </ul>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import StatusObjectBadge from './functional-comps/StatusObjectBadge';
import { RfxResponse } from '../js/models/rfxResponse';
// this is just the modal -- put a button somewhere on parent and call this things public methods using $refs

export default {
    name: 'RfxBulkReminderModal',
    components: {
        StatusObjectBadge,
    },
    props: {
        rfxId: {
            type: [Number, String],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            showModal: false,  // v-model for modal
            loading: false,  // loading initial list / count of vendors
            sending: false,  // loading indicator for when bulk reminders are sending
            saveComplete: false,  // toggle true when save is complete
            bulkReminderList: [],  // data from API, list of responses that will get a bulk reminder
            sentReminderCount: '',  // after reminders sent, response will include count, set it here as a string
        }
    },
    computed: {

    },
    methods: {
        // PUBLIC METHODS:
        openModal: function() {
            // call this to open the modal and start process of sending bulk reminder
            this.showModal = true;
        },
        closeModal: function() {
            this.showModal = false;
        },
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        clearError: function() {
            this.errorMsg = 'Error';
            this.error = false;
        },
        getBulkReminderList: function() {
            // get initial list from API
            this.loading = true;
            suppliosApi.rfx.getBulkReminderList(this.rfxId)
            .then(response => {
                this.clearError();
                console.log('Response from getting bulk supplier list');
                console.log(response);
                const responsesForReminders = response.data;
                this.bulkReminderList = responsesForReminders.map(resp => new RfxResponse(resp));
            })
            .catch(error => {
                this.handleError(error, 'Error while getting list of suppliers for reminders');
            })
            .then(() => {
                this.loading = false;
            })
        },
        sendBulkReminder: function(bvModalEvt) {
            bvModalEvt.preventDefault();  // need this to prevent closing of the modal
            this.sending = true;
            return suppliosApi.rfx.sendBulkReminder(this.rfxId)
                .then(response => {
                    this.clearError();
                    console.log('response from bulk reminder');
                    console.log(response);
                    this.sentReminderCount = response.data.reminder_count.toString();
                    this.saveComplete = true;
                    setTimeout(() => {
                        this.closeModal();
                    }, 2000);
                    /* this.$bvToast.toast(`Reminders sent to ${successfulReminderCount} vendors.`, {
                        title: 'Success!',
                        variant: 'success',
                    }); */
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while sending bulk reminders');
                    return false;
                })
                .then(wasSuccess => {
                    //this.sending = false;
                    return wasSuccess;
                })
        },
        onModalShow: function() {
            // this is like a mounted hook... 
            this.getBulkReminderList();
        },
        onModalHidden: function() {
            // reset things when modal hidden
            this.errorMsg = 'Error';
            this.error = false;
            this.loading = false;  // loading initial list / count of vendors
            this.sending = false;  // loading indicator for when bulk reminders are sending
            this.saveComplete = false;  // toggle true when save is complete
            this.bulkReminderList = [];  // data from API, list of responses that will get a bulk reminder
            this.sentReminderCount = '';
        }

    }
}
</script>

<style>

</style>